import {
  TABLE_CELL_WIDTH,
  TABLE_FIRST_CELL_WIDTH,
} from "@pages/platform-analysis/components/buttons/export-pdf/constant";

export class PDFFeatureAnalysisTableConfigs {
  static readonly MaxCharsPerLine = 48;

  static readonly FirstCellWidth = TABLE_FIRST_CELL_WIDTH;
  static readonly CellWidth = TABLE_CELL_WIDTH;

  static readonly SingleRowHeight = 20;
  static readonly DoubleRowHeight = 28;
  static readonly TableFooterHeight = 15;

  static readonly OverscoreHeight = 20;
  static readonly ExtendOverscoreHeight = 30;
}
